import React, { useCallback, useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import Reporting from './Reporting';
import OrgChart from './OrgChart';

function ReportingAndOrgChart() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const openAssignManager = useCallback(({ userId, managerId } = {}) => {
    setDrawerOpen(true);
    window.dispatchEvent(
      new CustomEvent('reporting:selectReportee', {
        detail: { userId, managerId, lockUser: userId != null },
      })
    );
  }, []);

  const closeDrawer = useCallback(() => setDrawerOpen(false), []);

  useEffect(() => {
    const handler = () => {
      setDrawerOpen(false);
    };
    window.addEventListener('reporting:changed', handler);
    return () => window.removeEventListener('reporting:changed', handler);
  }, []);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setDrawerOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, []);

  return (
    <div className="space-y-4">
      <OrgChart onAssignManager={openAssignManager} showAssignManagerButton />

      {drawerOpen && (
        <div className="fixed inset-0 z-[999]">
          <div
            className="absolute inset-0 bg-black/30"
            onClick={closeDrawer}
            role="presentation"
          />
          <div
            className="absolute right-0 top-0 h-full w-full max-w-[520px] bg-white shadow-[0_30px_80px_rgba(0,0,0,0.25)]"
          >
            <div className="h-full flex flex-col">
              <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
                <div className="text-sm font-black text-gray-900">Assign Manager</div>
                <button
                  type="button"
                  onClick={closeDrawer}
                  className="inline-flex items-center justify-center w-10 h-10 rounded-2xl bg-white border border-gray-100 text-gray-600 hover:bg-gray-50"
                  title="Close"
                >
                  <Icon icon="fluent:dismiss-24-regular" width={18} />
                </button>
              </div>

              <div className="flex-1 overflow-auto p-5">
                <Reporting embedded onClose={closeDrawer} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ReportingAndOrgChart;
